import React, { useEffect } from 'react';
import { useNavigate, Outlet, NavLink } from 'react-router-dom';
import TopNav from './components/TopNav';
import './Main.css';

const Main = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('isLoggedIn')) {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div className="main-container">
      <TopNav />
      <div className="content-wrapper">
        <Outlet />
      </div>
      <div className="bottom-nav">
        <NavLink
          to="/main/qr-scanner"
          className={({ isActive }) => (isActive ? 'active' : '')}
        >
          Điểm danh Đi Lễ
        </NavLink>
        <NavLink
          to="/main/qr-scanner-class"
          className={({ isActive }) => (isActive ? 'active' : '')}
        >
          Điểm danh Học Giáo Lý
        </NavLink>
        <NavLink
          to="/main/class-list/them-suc"
          className={({ isActive }) => (isActive ? 'active' : '')}
        >
          Danh sách lớp
        </NavLink>
      </div>
    </div>
  );
};

export default Main;